/* eslint-disable func-names */
/* eslint-disable no-param-reassign */
import { getList } from 'country-list-with-dial-code-and-flag';
import {
  timestampToDateTime,
  timestampToDate,
  timestampToDateWithDay,
  timestampToDateTimeMinute,
  timestampToDateTimeMinuteWithDay,
  timestampToTime,
  timestampToTimeM,
  timestampToM,
  timestampToMonth,
  toCurrencyNumber,
} from '@/util/format';

const countries = getList();
countries.sort((a, b) => (a.name > b.name ? 1 : -1));
const idx = countries.findIndex((c) => c.dial_code === '+886');
const tw = countries[idx];
tw.name = 'Taiwan';
countries.splice(idx, 1);
countries.unshift(tw);

function isPromise(p) {
  if (typeof p === 'object' && typeof p.then === 'function') {
    return true;
  }

  if (p.constructor.name === 'AsyncFunction') {
    return true;
  }

  return false;
}

export default {
  install(Vue) {
    Vue.prototype.$isPromise = isPromise;
    Vue.prototype.$splitPhone = (input) => {
      let country = '+886';
      let phone = '';
      if (input === 'None' || input === undefined || input === null) {
        return [country, phone];
      }
      for (let i = 0; i < countries.length; i += 1) {
        if (input.indexOf(countries[i].dial_code) === 0) {
          country = countries[i].dial_code;
        }
      }

      if (input === null) {
        return [country, phone];
      }
      if (input.indexOf(' ') > 0) {
        [country, phone] = input.split(' ');
      } else if (input !== 'None') {
        phone = `${country === '+886' ? '0' : ''}${input.replace(country, '')}`;
      }
      return [country, phone];
    };
    Vue.prototype.$getShowPhone = (input) => {
      if (input === 'None' || input === undefined || input === null) {
        return '';
      }
      let country = '';
      let phone = '';
      [country, phone] = Vue.prototype.$splitPhone(input);
      if (country === '+886' && phone.indexOf('0') === 0) {
        phone = phone.substring(1);
      }
      if (phone === '') {
        return '';
      }
      return `${country}-${phone}`;
    };
    Vue.prototype.$getPhone = (country, phone) => {
      if (phone === '') {
        return '';
      }
      return `${country} ${phone}`;
    };
    Vue.prototype.$execWithLoading = async function (func, errFunc) {
      return this.$execWithLoadingMessage('載入中', func, errFunc);
    };
    Vue.prototype.$execWithLoadingMessage = async function (msg, func, errFunc) {
      const loading = this.$loading({
        lock: true,
        text: msg,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });
      let promise = new Promise((r) => {
        r();
      });

      return new Promise((r) => {
        setTimeout(async () => {
          promise = promise.then(() => func.apply(this));
          try {
            await promise;
          } catch (e) {
            console.log(`loading exception: ${e}`);
            console.trace();
            if (errFunc !== undefined) {
              try {
                errFunc(e);
              } catch (e2) {
                console.log(e2);
              }
            }
          }
          loading.close();
          r();
        }, 10);
      });
    };
    Vue.prototype.$defaultLoading = function () {
      return this.$loading({
        lock: true,
        text: '載入中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });
    };
    Vue.prototype.$dateToTimestamp = (d) => {
      const result = parseInt(
        (new Date(d)).getTime() / 1000,
        10,
      );
      if (Number.isNaN(result)) {
        return undefined;
      }
      return result;
    };
    Vue.prototype.$timestampToDateTime = (input, dft) => timestampToDateTime(input, dft);
    Vue.prototype.$timestampToDateTimeMinute = (input, dft) => timestampToDateTimeMinute(input, dft);
    Vue.prototype.$timestampToDateTimeMinuteWithDay = (input, dft) => timestampToDateTimeMinuteWithDay(input, dft);
    Vue.prototype.$timestampToDate = (input) => timestampToDate(input);
    Vue.prototype.$timestampToDateWithDay = (input) => timestampToDateWithDay(input);
    Vue.prototype.$timestampToTime = (input) => timestampToTime(input);
    Vue.prototype.$timestampToTimeM = (input) => timestampToTimeM(input);
    Vue.prototype.$timestampToM = (input) => timestampToM(input);
    Vue.prototype.$timestampToMonth = (input) => timestampToMonth(input);
    Vue.prototype.$toCurrencyNumber = (input) => toCurrencyNumber(input);
    Vue.prototype.$showSuccess = function (title) {
      this.$notify.success({
        title,
      });
    };
    Vue.prototype.$showError = function (title, message) {
      this.$notify.error({
        title,
        message,
        // 有詳細原因時停久一點，讓使用者來得及看完或截圖回報
        duration: message ? 10000 : 4500,
      });
    };
    Vue.prototype.$showWarn = function (title, message) {
      this.$notify({
        title,
        message,
        type: 'warning',
      });
    };
    Vue.prototype.$showAxiosException = function (title, e) {
      // 容錯：只傳錯誤物件時（$showAxiosException(e)）改用通用標題
      if (e === undefined && typeof title === 'object' && title !== null) {
        e = title;
        title = '操作失敗';
      }
      const status = e?.response?.status;
      const rawErr = e?.response?.data?.error;
      // 401 且帶有具體錯誤碼（如 user 後端舊密碼錯誤回 401 invalid_password）時不視為連線過期
      const isSessionExpired = status === 401 && (!rawErr || rawErr === 'forbidden' || rawErr === 'unauthorized');
      if (isSessionExpired) {
        this.$showError(this.$tryMsg('errorSessionExpire'));
        this.$router.push('/login');
        return;
      }
      let reason = rawErr ? this.$tryMsg(`axiosErr.${rawErr}`) : '';
      if (!reason && status) {
        // 後端沒給錯誤碼或查無中文對照時，改依 HTTP 狀態碼顯示中文原因
        reason = this.$tryMsg(`httpStatus.${status}`);
      }
      if (!reason && e?.request && !e?.response) {
        reason = this.$tryMsg('httpStatus.network');
      }
      // 仍查無對照時退回顯示後端原文，避免只顯示「<title>: 」
      reason = reason || rawErr || this.$tryMsg('axiosErr.unknown');
      setTimeout(() => {
        this.$showError(`${title}: ${reason}`);
      }, 10);
    };
    Vue.prototype.$addUILog = function (args) {
      const debug = document.querySelector('#debug');
      if (debug) {
        const orig = debug.textContent;
        debug.textContent = `${orig}\n\n${args.map((a) => {
          if ((typeof a).toLowerCase() === 'object') {
            return JSON.stringify(a);
          }
          return a.toString();
        }).join('\n')}`;
      }
    };
    Vue.prototype.$waitMs = async function (ms) {
      return new Promise((r) => {
        setTimeout(() => {
          r();
        }, ms);
      });
    };
    Vue.prototype.$goLink = function (url) {
      if (url) {
        window.open(url, '_blank');
      }
    };

    Vue.prototype.$copy = function (text, notify) {
      const input = document.createElement('input');
      input.value = text;
      const body = document.querySelector('body');
      body.append(input);

      input.select();
      document.execCommand('copy');
      input.remove();

      if (notify) {
        this.$showSuccess(`已經成功複製 ${text}`);
      }
    };

    Vue.prototype.$showConfirm = function ({
      title, content, confirmButtonText, cancelButtonText, confirmType, customClass,
    }) {
      return new Promise((resolve, reject) => {
        this.$confirm(content, title, {
          confirmButtonText,
          cancelButtonText,
          type: confirmType,
          customClass,
        }).then(async () => {
          resolve();
        }).catch(() => {
          reject();
        });
      });
    };
    Vue.prototype.$getVersion = async function () {
      let beVersion = '-';
      let beUpdateTime = '-';
      let version = '-';
      let updateTime = '-';
      try {
        const response = await fetch('/backend-version.json');
        const data = await response.json();
        beVersion = data.commit.slice(0, 8);
        beUpdateTime = this.$timestampToDateTimeMinute(data.updated_at);
      } catch (e) {
        console.error(e);
      }
      if (window.version) {
        version = window.version;
        updateTime = window.updated;
      }
      return `Version: ${version}, Updated: ${updateTime}, BEVersion: ${beVersion}, BEUpdated: ${beUpdateTime}`;
    };
    Vue.prototype.$fileToBase64 = function (file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          resolve(reader.result);
        };
        reader.onerror = (error) => {
          reject(error);
        };
      });
    };
    Vue.prototype.$getTimezoneOffset = function () {
      return -new Date().getTimezoneOffset() / 60;
    };

    Vue.prototype.$getTimezoneString = function () {
      const offset = new Date().getTimezoneOffset();
      const hours = Math.floor(Math.abs(offset) / 60);
      const minutes = Math.abs(offset) % 60;
      const sign = offset > 0 ? '-' : '+';

      return `UTC${sign}${hours}${minutes !== 0 ? `:${minutes.toString().padStart(2, '0')}` : ''}`;
    };
  },
};
